<template>
    <div class="mt-3">
        <label
            for=""
            class="font-14"
        >
            Cor do texto
        </label>
        
        <div class="d-flex align-items-center flex-wrap" style="gap: 0.5em;">
            <button
                type="button"
                id="picker-reset"
                :class="['picker-default d-flex justify-content-center align-items-center mr-3', activeColor.value == null && 'active']"
                style="background-color: transparent;"
                @click="resetStyleColor"
                v-b-tooltip.hover
                title="Cor padrão do site"
            >
                Padrão
            </button>

            <button
                type="button"
                v-for="(color, index) in templateColors" 
                :key="index"
                :id="`picker-${index}`"
                :class="['picker-wrapper', color.value === activeColor.value ? 'active' : '']"
                @click="setStyleColor(color)"
                v-b-tooltip.hover
                :title="color.name"
            >
                <div
                    :style="`background-color: ${color.value};`"
                    class="color"
                ></div>
            </button>

            <!-- botão color picker -->
            <div :class="['picker-custom-container d-flex justify-content-center align-items-center flex-row ml-3', activeColor.value && templateColors.findIndex((color) => color.value === activeColor.value) === -1 ? 'active' : '']">
                <input
                    ref="pickerCustom"
                    type="color"
                    id="picker-custom"
                    class="picker-custom"
                    v-b-tooltip.hover
                    title="Cor personalizada"
                    :value="activeColor ? activeColor.value : '#FFFFFF'"
                    @change="setStyleColorByPicker"
                />

                <input
                    placeholder="#000000"
                    class="ml-3 picker-custom-input"
                    type="text"
                    v-model="customColor"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'SettingFrameStyleColor',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            templateColors: {},
            activeColor: {},
            customColor: '',
        }
    },
    methods: {
        setStyleColor(color) {
            this.activeColor = color;

            this.customColor = color.value;
        },
        setStyleColorByPicker(event) {
            this.customColor = event.target.value;
        },
        resetStyleColor() {
            this.activeColor = {};

            this.customColor = '';
        }
    },
    watch: {
        activeColor(newVal, oldVal) {
            this.$emit('onChangeStyleColor', newVal.value)
        },
        customColor(newVal, oldVal) {
            if (newVal) {
                this.setStyleColor({
                    name: "Personalizado",
                    value: newVal,
                });
            }
        }
    },
    computed: {
        ...mapGetters('dashboardModule', ['getDefaultFrameColors']),
    },
    created() {
        this.templateColors = this.getDefaultFrameColors;

        if (this.item.extra.style.color) {
            this.setStyleColor({
                value: this.item.extra.style.color,
            })
        }
    }
}
</script>

<style scoped>
.picker-default {
    height: 36px;
    border-radius: 20px;
    padding-left: 1rem;
    padding-right: 1rem;
    border: 2px solid #cccccc;
}

input[type="color"].picker-custom::-webkit-color-swatch-wrapper {
    border: 2px solid #ededed;
    border-radius: 50%;
	padding: 0;
    height: 100%;
    width: 100%;
}
input[type="color"].picker-custom::-webkit-color-swatch {
    border: 2px solid #ededed;
    height: 100%;
    width: 100%;
    border-radius: 50%;
	border: none;
}

.picker-wrapper {
    cursor: pointer;
    background-color: transparent;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    border: 2px solid transparent;
    transform: scale(1);
    transition: all 0.2s ease-in-out;
    padding: 3px;
}

.picker-custom-container {
    position: relative;
    border-radius: 20px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    border: 2px solid #cccccc;
}

.picker-custom {
    position: relative;
    padding: 3px;
    cursor: pointer;
    background-color: transparent;
    height: 36px;
    width: 36px;
    border-radius: 50%;
    border: 2px solid transparent;
    transform: scale(1);
    transition: all 0.2s ease-in-out;
}

.picker-custom-input {
    border: none;
    background: transparent;
}

.picker-wrapper .color {
    border-radius: 50%;
    height: 100%;
    width: 100%;
    border: 2px solid #ededed;
    background-color: #000;
}

.picker-wrapper.active, .picker-default.active, .picker-custom-container.active {
    border: 2px solid var(--main-color);
}

.picker-wrapper + .picker-wrapper {
    margin-left: 0.725rem;
}

@media screen and (max-width: 568px) {
    .picker-wrapper {
        height: 24px;
        width: 24px;
    }

    .picker-custom {
        height: 24px;
        width: 24px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameStyleColor.vue